import { Button, Image, Link, Stack, Text } from '@chakra-ui/react';
import { OpenNewWindow } from 'iconoir-react';
import { useTranslation } from 'react-i18next';
import { ASSISTANT_PROVIDERS, claudeInstallUrl } from './assistant-providers';
import { AssistantConnectStep } from './AssistantConnectStep';

/** Claude takes a prefilled install link: one click opens its dialog, the brand confirms. */
export const ClaudeConnectSteps: React.FC = () => {
  const { t } = useTranslation();
  const { name, logo } = ASSISTANT_PROVIDERS.claude;

  return (
    <Stack gap={5}>
      <AssistantConnectStep index={1} title={t('integrations.assistants.claude.addStep')}>
        <Button asChild size="sm" alignSelf="flex-start">
          <a href={claudeInstallUrl('personal')} target="_blank" rel="noopener noreferrer">
            <Image src={logo} alt="" boxSize="14px" />
            {t('integrations.assistants.claude.add')}
            <OpenNewWindow width={14} height={14} />
          </a>
        </Button>
        <Text fontSize="xs" color="fg.muted">
          {t('integrations.assistants.claude.orgHint')}{' '}
          <Link
            href={claudeInstallUrl('organization')}
            target="_blank"
            rel="noopener noreferrer"
            color="fg"
            textDecoration="underline"
          >
            {t('integrations.assistants.claude.orgAdd')}
          </Link>
        </Text>
      </AssistantConnectStep>
      <AssistantConnectStep
        index={2}
        title={t('integrations.assistants.dialog.signInStep', { name })}
      />
    </Stack>
  );
};
